export default __webpack_public_path__ + "static/media/logo_black.6aacef41.svg";